// extracted by mini-css-extract-plugin
module.exports = {"MacroList":"MacroSearch_MacroList__2-4D6","title":"MacroSearch_title__3Setq","newMacro":"MacroSearch_newMacro__1N3Yg"};